
export default  {
	strict: false,

  state:{
    metodos:[]
  },

	getters: {
		metodos_pago: state => state.metodos,
	},

	mutations: {
		get_metodos_pago: (state, metodos) => {
			state.metodos = metodos
		},
	},

	actions: {
		getMetodosPago: (context, vm) => {
			axios.get('api/metodos-de-pago').then(res => {        
				context.commit('get_metodos_pago', res.data.metodos)
			}, res => {

			})
		},
	}
}

